import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

import { AbstractRegisterAdaptor } from '../../../common/auth/register/abstract-register.adaptor';
import { ErrorsMap } from '../../../common/form/abstract-request-form.adaptor';
import { normalizePhoneAU } from '../../../common/validators/phone-au.validator';

type RegisterMethod = 'password' | 'email' | 'phone';

export interface BaseRegisterFormData {
  method: RegisterMethod;

  first_name: string;
  last_name: string;
  tnc: boolean;
}

export interface RegisterFormDataEmail extends BaseRegisterFormData {
  email: string;
}

export interface RegisterFormDataPhone extends BaseRegisterFormData {
  phone: string;
}

export interface RegisterFormDataEmailAndPassword extends RegisterFormDataEmail {
  password: string;
}

export type RegisterFormDataAll = RegisterFormDataEmail & RegisterFormDataPhone & RegisterFormDataEmailAndPassword;

type RegisterFormData = RegisterFormDataEmail | RegisterFormDataPhone | RegisterFormDataEmailAndPassword;

const URLs: Record<RegisterMethod, string> = {
  email: '/accounts/email_register',
  phone: '/accounts/phone_register',
  password: '/accounts/register',
};

@Injectable()
export class RegisterAdaptor extends AbstractRegisterAdaptor<RegisterFormData, unknown> {
  private http = inject(HttpClient);

  private navCtrl = inject(NavController);

  override onRequest({ method, ...formData }: RegisterFormData) {
    if ('phone' in formData) {
      formData.phone = normalizePhoneAU(formData.phone);
    }
    return this.http.post(URLs[method], {
      account: { ...formData, t_and_c_accepted_at: new Date().toJSON() },
    });
  }

  override onSuccess({ method, email, phone }: RegisterFormDataAll) {
    if (method === 'password') this.navCtrl.navigateRoot(['login']);
    else this.navCtrl.navigateRoot(['magic-link', 'register', method], { queryParams: { email, phone } });
  }

  override onMapError(_formData: RegisterFormData, errorRes: HttpErrorResponse): ErrorsMap {
    if (errorRes.status === 409) {
      return { base: 'User already exist' };
    }
    return null;
  }
}
